import { TradingModal } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

import type { PricingIndex, CreatePricingIndexPayload } from '@/api/services/settings/pricing-indices.service';

import PricingIndexForm from '../forms/PricingIndexForm';

import usePricingIndexForm from '../../hooks/utils/usePricingIndexForm';

type Props = {
  selectedPricingIndex: PricingIndex;
  setSelectedPricingIndex: (pricingIndex: PricingIndex | null) => void;
  handleUpdatePricingIndex: (id: number, payload: Partial<CreatePricingIndexPayload>) => Promise<void> | void;
};

export default function UpdatePricingIndexModal({
  selectedPricingIndex,
  setSelectedPricingIndex,
  handleUpdatePricingIndex,
}: Props) {
  const { t } = useTranslation();

  const { form, isSubmitting, errors, updateField, handleSubmit } = usePricingIndexForm({
    initialState: {
      name: selectedPricingIndex.name,
      timeLimitLower: selectedPricingIndex.timeLimitLower,
      timeLimitUpper: selectedPricingIndex.timeLimitUpper,
    },
    onSubmit: async (payload) => {
      await handleUpdatePricingIndex(selectedPricingIndex.id, payload);
      setSelectedPricingIndex(null);
    },
  });

  return (
    <TradingModal
      titleText={t('settings.pricingIndicesTab.modal.updateTitle')}
      bodyText={
        <PricingIndexForm
          form={form}
          isSubmitting={isSubmitting}
          errors={errors}
          updateField={updateField}
          handleSubmit={handleSubmit}
          type="update"
        />
      }
      open
      onClose={() => setSelectedPricingIndex(null)}
      styleModal={{
        minHeight: '35%',
        overflow: 'visible',
      }}
    />
  );
}
